// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ks-0";
export var fileCarousel = "_ks-2";
export var removeFileButton = "_ks-1";